import { LayoutContext } from "context/LayoutContext";
import React, { useContext, useEffect, useState } from "react";
import AccordionTransaction from "./_components/accordion-trx";
import { getDetailRiwayatStok } from "apis/detail_riwayat_stok";
import moment from "moment";
import "moment/locale/id";

moment.locale("id");
const Index = () => {
  const { setHeaderComponent } = useContext(LayoutContext);
  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setHeaderComponent([]), []);

  useEffect(() => {
    (async () => {
      try {
        // Get params from URL
        const urlParams = new URLSearchParams(window.location.search);
        const idGudang = urlParams.get("id_gudang");
        const idProduct = urlParams.get("id_product");

        // If parameters aren't in URL, redirect or show error
        if (!idGudang || !idProduct) {
          console.error(
            "Missing required parameters: id_gudang and id_product"
          );
          setLoading(false);
          return;
        }

        // Build query with parameters from URL
        let query = `?id_gudang=${idGudang}&id_product=${idProduct}`;

        const resp = await getDetailRiwayatStok(query);

        setInfo(resp);
      } catch (error) {
        console.error("Error when fetch : ", error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 700);
      }
    })();
  }, []);

  // Show a message if parameters are missing
  if (!loading && !info) {
    return (
      <div className="mt-4 rounded-xl bg-white p-6 shadow-sm">
        <p className="text-lg text-red-500">
          Parameter tidak lengkap. Harap sertakan id_gudang dan id_product.
        </p>
      </div>
    );
  }

  return (
    <>
      {loading ? (
        <div className="h-40 w-full animate-pulse rounded-xl bg-gray-200" />
      ) : (
        <>
          <h2 className="my-4 text-lg font-semibold">List Aktivitas</h2>
          <div className="flex flex-col gap-2">
            {info?.data?.map((act) => (
              <div
                className="rounded-xl bg-white p-6 shadow-sm"
                key={act.activity_date}
              >
                <div className="mb-6 flex flex-col items-start justify-between">
                  <div>
                    <h2 className="text-xl font-bold">{act.activity_name}</h2>
                  </div>
                  <div className="mt-0.5 text-sm text-gray-600">
                    {moment(act.activity_date).format("DD MMMM YYYY HH:mm")}
                  </div>
                </div>

                <div className="border-t pt-4">
                  <AccordionTransaction
                    data={act.activity_details}
                    parentData={act}
                  />
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default Index;
